import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuth } from '@/features/auth/hooks/useAuth'
import { BootScreen } from '@/shared/components/ui/BootScreen'
import { getDashboardPathForRole } from '@/shared/constants/roles'
import { ROUTES } from '@/shared/constants/routes'

export function ProtectedRoute({ allowedRoles }) {
  const location = useLocation()
  const { isAuthenticated, isBootstrapping, role } = useAuth()

  if (isBootstrapping) {
    return <BootScreen />
  }

  if (!isAuthenticated || !role) {
    return (
      <Navigate to={ROUTES.LOGIN} replace state={{ from: location.pathname }} />
    )
  }

  if (allowedRoles?.length && !allowedRoles.includes(role)) {
    return <Navigate to={getDashboardPathForRole(role)} replace />
  }

  return <Outlet />
}
